export var isJpeg = function (url) {
    return url.includes(".jpeg");
};
export var jpgToPng = function (url) {
    if (isJpeg(url)) {
        return url.replace(".jpeg", ".png");
    }
    return url.replace(".jpg", ".png");
};
export var pngToJpg = function (url) {
    if (isJpeg(url)) {
        return url.replace(".jpeg", ".jpg");
    }
    return url.replace(".png", ".jpg");
};
